/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_kr as kr,
} from "../../runtime/index.jsx";
export function MarcaCarga(e) {
  let t = (0, ReactCompiler.c)(15),
    { checked: n, onChange: r, disabled: i, children: a, className: o } = e,
    s = i !== void 0 && i,
    c = `flex items-center gap-2 text-sm ${s ? `cursor-not-allowed opacity-60` : `cursor-pointer`} ${o === void 0 ? `` : o}`,
    l;
  t[0] === r
    ? (l = t[1])
    : ((l = (e) => r(e.target.checked)), (t[0] = r), (t[1] = l));
  let u;
  t[2] !== n || t[3] !== s || t[4] !== l
    ? ((u = (
        <input
          type={`checkbox`}
          checked={n}
          disabled={s}
          onChange={l}
          className={`peer absolute inset-0 h-full w-full cursor-[inherit] appearance-none rounded border border-(--border) bg-(--bg) outline-none transition checked:border-(--accent) checked:bg-(--accent) focus-visible:ring-2 focus-visible:ring-(--accent-bg)`}
        />
      )),
      (t[2] = n),
      (t[3] = s),
      (t[4] = l),
      (t[5] = u))
    : (u = t[5]);
  let d;
  t[6] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((d = (0, JSXRuntime.jsx)(kr, {
        className: `pointer-events-none h-3 w-3 text-(--accent-fg) opacity-0 transition peer-checked:opacity-100`,
      })),
      (t[6] = d))
    : (d = t[6]);
  let f;
  t[7] === u
    ? (f = t[8])
    : ((f = (
        <span
          className={`relative inline-flex h-4 w-4 shrink-0 items-center justify-center`}
          children={[u, d]}
        />
      )),
      (t[7] = u),
      (t[8] = f));
  let p;
  t[9] === a
    ? (p = t[10])
    : ((p = a && <span className={`text-(--text-h)`} children={a} />),
      (t[9] = a),
      (t[10] = p));
  let m;
  return (
    t[11] !== c || t[12] !== f || t[13] !== p
      ? ((m = <label className={c} children={[f, p]} />),
        (t[11] = c),
        (t[12] = f),
        (t[13] = p),
        (t[14] = m))
      : (m = t[14]),
    m
  );
}
